import { styled as t, Box as p, Typography as s } from "@mui/material";
import { RONIN_QRCODE_REFRESH as S } from "../../constants/login.js";
import { useLoginErrorContext as A } from "../../contexts/LoginErrorContext.js";
import w from "../../../temp-lib/assets/icons/icon-ronin.svg.js";
import O from "../../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import M from "../../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import Q from "../../../temp-lib/components/share/next/Image.js";
import { AdeptusInputMode as j } from "../../../temp-lib/constants/adeptus.js";
import { ChainAddressType as C, ChainNetworkType as z } from "../../../temp-lib/constants/chain.js";
import { WalletExtensionRdns as y, WalletType as a } from "../../../temp-lib/constants/web3.js";
import { useAccountContext as B } from "../../../temp-lib/contexts/account/AccountContext.js";
import { useMessageContext as _ } from "../../../temp-lib/contexts/share/MessageContext.js";
import D from "../../../temp-lib/hooks/generic/useRecursiveCalling.js";
import R from "../../../temp-lib/hooks/web3/useWeb3.js";
import F from "../../../ui-lib/components/MuiLoading.js";
import G from "../../../wallet-lib/hooks/useWalletConnect.js";
import { QRCodeSVG as V } from "qrcode.react";
import { useEffect as $, useCallback as b } from "react";
import { useTranslation as q } from "react-i18next";
import { jsxs as k, jsx as o } from "react/jsx-runtime";
const H = t(p)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  position: relative;
  background-color: #1c1f25;
  padding: 135px 40px 80px 40px;
  overflow: auto;
  ${(r) => r.theme.breakpoints.up("res1024")} {
    width: 560px;
  }
  ${(r) => r.theme.breakpoints.down("res1024")} {
    width: 100%;
  }
`, J = t(s)`
  font-size: 28px;
  font-weight: 700;
  text-align: center;
`, K = t(s)`
  font-size: 12px;
  text-align: center;
`, P = t(p)`
  background-color: white;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  min-width: 220px;
  max-width: 220px;
  margin: 10px auto;
`, U = t(F)`
  color: black;
`, X = t(Q)`
  filter: grayscale(100%) brightness(3);
  height: 24px;
  width: 24px;
`, Y = t(s)`
  font-size: 14px;
  font-weight: 300;
  text-align: center;
`, Z = t(M)`
  --background-color: #1473e9;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  gap: 6px;
  height: 55px;
  margin-left: auto;
  width: 100%;
  :hover {
    filter: brightness(0.9);
  }
`, tt = t(p)`
  display: flex;
  justify-content: center;
  border-top: 1px dashed #979797;
  position: relative;
  margin: 30px auto;
  width: 100%;
`, ot = t(s)`
  background-color: #1c1f25;
  width: 35px;
  text-align: center;
  color: white;
  top: -12px;
  position: absolute;
`, et = t(O)`
  margin-top: 16px;
  width: 100%;
`, kt = (r) => {
  const {
    className: W,
    isActive: v
  } = r, {
    t: n
  } = q(), {
    onWalletLoginError: d,
    onQrCodeLoginError: m
  } = A(), {
    loginByWallet: c
  } = B(), {
    setSnackInfo: g
  } = _(), {
    validateWalletInstalled: f,
    getWalletConnections: I,
    disconnectWallet: T
  } = R(), {
    roninQRCode: u
  } = G(), {
    connectors: L
  } = R(), x = L.find((e) => e.id === y.WalletConnect);
  $(() => {
    const i = I().find((l) => l.connector.id === y.WalletConnect);
    i && T(i.connector);
  }, []);
  const h = b(async (e) => {
    try {
      if (!x)
        return;
      await c(a.RoninMobile, C.RONIN);
    } catch (i) {
      const l = i;
      e && (e.reset(), h(null)), m(l);
    }
  }, [x, c, m]), {
    remainSecond: N
  } = D({
    active: v,
    duration: S,
    callback: h
  }), E = b(async () => {
    const e = a.Ronin;
    try {
      f(z.Ronin, [a.Ronin]), await c(e, C.RONIN), g({
        message: n("login.general.login_success"),
        serverity: "success"
      });
    } catch (i) {
      d(i, {
        walletType: e
      });
    }
  }, [c, g, d, f, n]);
  return /* @__PURE__ */ k(H, {
    className: W,
    children: [/* @__PURE__ */ o(J, {
      children: n("login.wallet.title")
    }), /* @__PURE__ */ o(K, {
      children: n("login.wallet.description")
    }), /* @__PURE__ */ o(P, {
      children: u ? /* @__PURE__ */ o(V, {
        size: 300,
        level: "L",
        value: u,
        imageSettings: {
          src: w,
          excavate: !0,
          width: 32,
          height: 45
        }
      }) : /* @__PURE__ */ o(U, {
        loading: !0
      })
    }), /* @__PURE__ */ o(Y, {
      children: n("login.qrcode.refresh", {
        count: N
      })
    }), /* @__PURE__ */ o(tt, {
      children: /* @__PURE__ */ o(ot, {
        children: n("login.wallet.or")
      })
    }), /* @__PURE__ */ k(Z, {
      onClick: E,
      children: [/* @__PURE__ */ o(X, {
        src: w
      }), n("login.general.button.ronin")]
    }), /* @__PURE__ */ o(et, {
      showFoot: !1,
      mode: j.AccountLogin
    })]
  });
};
export {
  kt as default
};
//# sourceMappingURL=RoninLoginSection.js.map
